export default {
  room: null,
  audioTrack: null,
  reconnecting: false,
};



// WEBPACK FOOTER //
// ./src/store/manual_calls/state.js